<script setup>
    import {useRoute} from "vue-router";
    import {useModalStore} from "../../store/modal";

    const modalStore = useModalStore()
    defineProps({
        heading: {
            type: String,
            required: true
        }
    })
</script>

<template>
    <div class="section-header">
        <div class="heading-block">
            <h1>{{heading }}</h1>

            <brand-button v-if="useRoute().name === 'users'" as="button" variant="primary" @click.prevent="modalStore.open('AddUser', null, null, 'bottom-right')">Add<ah-icon name="plus-default" /></brand-button>
        </div>

        <div class="section-header-actions">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss">
    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 2rem;

        .heading-block {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;

            h1 {
                @include font(3, null, black);
            }

            .brand-button {
                display: none;
                align-items: center;
                gap: 1rem;

                .icon {
                    fill: var(--color-white);
                }

                @include mobile() {
                    display: flex;
                }
            }
        }

        .section-header-actions {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 1rem;

            @include mobile() {
                width: 100%;
            }
        }

        @include dark() {
            .heading-block {
                h1 {
                    color: #fff;
                }
            }
        }

        @include mobile() {
            flex-direction: column;
            align-items: flex-start;
            padding: 0;
            gap: 2rem;
        }
    }
</style>
